<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')" v-if="checkPermissionButton('新增')">新增</el-button>
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.inventory_category_name" placeholder="请输入产品名称" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="inventoryCategoryName" label="产品名称"></el-table-column>
            <el-table-column prop="inventoryCategoryPercentUp" label="上游费率"></el-table-column>
            <el-table-column prop="inventoryCategoryPercentDown" label="下游费率"></el-table-column>
            <el-table-column prop="inventoryCategoryMemo" label="产品备注"></el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.createTime) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="showDetail(scope.row)" type="text" size="small" v-if="checkPermissionButton('查看')">查看</el-button>
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small" v-if="checkPermissionButton('编辑')">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small" v-if="checkPermissionButton('删除')">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="50%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="110px">
                    <el-form-item label="产品名称">
                        <el-input v-model="handleInfo.inventoryCategoryName"></el-input>
                    </el-form-item>
                    <el-form-item label="上游费率">
                        <el-input v-model="handleInfo.inventoryCategoryPercentUp"></el-input>
                    </el-form-item>
                    <el-form-item label="下游费率">
                        <el-input v-model="handleInfo.inventoryCategoryPercentDown"></el-input>
                    </el-form-item>
                    <el-form-item label="产品备注">
                        <el-input v-model="handleInfo.inventoryCategoryMemo"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 详情 -->
        <div v-if="isDetail" style="position: fixed; top: 0px; left: 0px; z-index: 9; width: 100%; height: 100vh; background: #FFFFFF;">
            <PaymentDetailComponent :category-id="categoryId" @close="isDetail = false"></PaymentDetailComponent>
        </div>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"

import PaymentDetailComponent from "@/components/PaymentDetailComponent.vue"

export default {
    components: {
        PaymentDetailComponent,
    },
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin],
    data: function () {
        return {
            categoryId: "",
            isDetail: false,
        }
    },
    methods: {
        showDetail: function(row) {
            this.categoryId = row.inventoryCategoryId;
            this.isDetail = true;
        },
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>